'use strict';


var RemoteWallet = class {
	constructor(app) {
		this.app = app;
		this.name = 'GoodDollar';
	}

	async getShortPaymentLink(params) {
		return this.getPaymentLink(params);
	}

	async getPaymentLink(params) {
		let mvcmywidget = this.app.getMvcMyWidget();

		let start_conditions = this.app.getVariable('start_conditions');

		if (!start_conditions)
		return;
		
		var base_uri = await this.app.getRemoteWalletUrl((params.device ? params.device : null));
		var uri = base_uri;

		uri += '?code=';

		// transaction
		let _gdparams = {};

		if (params.to_address) {
			_gdparams.recipient = params.to_address;
			_gdparams.r = params.to_address;
		}

		if (params.amount) {
			_gdparams.amount = params.amount;
			_gdparams.a = params.amount;
		}

		// callbacks and returns
		if (params.callbackurl)
		_gdparams.callbackurl = params.callbackurl;

		if (params.returnurl)
		_gdparams.returnurl = params.returnurl;

		// additional data (specific to GoodDollar)
		if (params.invoice_id)
		_gdparams.invoiceId = params.invoice_id;

		if (params.tx_data) {
			let _keys = Object.keys(params.tx_data);

			for (var i = 0; i < _keys.length; i++) {
				let _key = _keys[i];
				if (_key.startsWith('gdd_') && (_key.length > 4))
				_gdparams[_key.substring(4)] = params.tx_data[_key];
			}
		}

		uri += this.app.encodebase64(JSON.stringify(_gdparams));

		return uri;
	}

	async onPay(params) {
		let uri = await this.getPaymentLink(params);

		// jump
		this.app.gotoUrl(uri);
	}

	async getTransactionInfo(sessionuuid, walletuuid, schemeuuid, txhash) {
		let mvcmywidget = this.app.getMvcMyWidget();

		// default
		let RemoteWallet = mvcmywidget.getRegisteredClass('RemoteWallet');
		let remotewallet = new RemoteWallet(this.app);

		return remotewallet.getTransactionInfo(sessionuuid, walletuuid, schemeuuid, txhash);
	}
}

if ( typeof window !== 'undefined' && typeof window.GlobalClass !== 'undefined' && window.GlobalClass ) {
	var _GlobalClass = window.GlobalClass;
}
else if (typeof window !== 'undefined') {
	var _GlobalClass = ( window && window.simplestore && window.simplestore.Global ? window.simplestore.Global : null);
}
else if (typeof global !== 'undefined') {
	// we are in node js
	var _GlobalClass = ( global && global.simplestore && global.simplestore.Global ? global.simplestore.Global : null);
}

_GlobalClass.registerModuleClass('mvc-mywidget', 'GoodDollar', RemoteWallet);
